<template>
    <div class="ad-banner-container">
        <div class="ad-banner" :style="{ aspectRatio: aspectRatio }">
            <a :href="adBanner?.link" target="_blank" class="ad-content" @click.prevent="handleAdClick">
                <img
                    :src="adBanner?.blob.url"
                    class="ad-image"
                    :class="{ 'has-hover': hasHoverImage }"
                    alt=""
                />
                <img
                    v-if="hasHoverImage"
                    :src="hoverImage"
                    class="ad-image ad-image-hover"
                    alt=""
                />
            </a>
        </div>
    </div>
</template>

<script>
export default {
    name: "adBanner",
    props: {
        adBanner: {
            type: Object,
        },
        adBanners: {
            type: Array,
            default: null
        },
        aspectRatio: {
            type: String,
            default: '16 / 3'
        }
    },
    computed: {
        hasHoverImage() {
            return this.hoverImage !== null;
        },
        hoverImage() {
            if (!this.adBanner || !this.adBanner.placement) {
                return null;
            }

            // placment name hover
            const hoverPlacement = `${this.adBanner.placement}_hover`;

            // find hover in the array
            const hoverBanner = this.adBanners.find(
                banner => banner.placement === hoverPlacement
            );

            return hoverBanner?.blob?.url || null;
        }
    },
    methods: {
        handleAdClick() {
            // Track the ad click
            appendToDataLayer(null, 'ad_banner_click', {
                banner_id: this.adBanner.placement,
            });

            // Navigate to the link after tracking
            if (this.adBanner?.link) {
                setTimeout(() => {
                    window.open(this.adBanner.link, '_blank');
                }, 500);
            }
        }
    }
}
</script>

<style scoped>
.ad-banner-container {
    width: 100%;
    margin: 20px 0;
}

.ad-banner {
    position: relative;
    width: 100%;
    overflow: hidden;
    border-radius: 8px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    cursor: pointer;
    transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.ad-banner:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.2);
}

.ad-content {
    position: relative;
    width: 100%;
    height: 100%;
    display: block;
    text-decoration: none;
}

.ad-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
}

.ad-image.has-hover {
    position: relative;
    z-index: 2;
}

.ad-image-hover {
    position: absolute;
    top: 0;
    left: 0;
    opacity: 0;
    z-index: 1;
}

.ad-banner:hover .ad-image.has-hover {
    opacity: 0;
}

.ad-banner:hover .ad-image-hover {
    opacity: 1;
}

@media (max-width: 768px) {
    .ad-banner {
        border-radius: 6px;
    }
}

@media (max-width: 480px) {
    .ad-banner {
        border-radius: 4px;
    }
}
</style>
